module.exports = __webpack_public_path__ + "img/card-select-type-eat-in-icon.dd1ca03c.svg";